import { useState } from 'react';
import { useIntl } from 'react-intl';

import { IconTick } from '@xing-com/icons';
import { xdlPaletteMint07 } from '@xing-com/tokens';

import { useSearchAndShuffleContext } from '../../context';

import { DumbTile } from './dumb-tile';
import {
  interrupterCards,
  type InterrupterData,
} from './interrupter-card-data';
import {
  Container,
  Title,
  Description,
  TagList,
  TagItem,
  ButtonContainer,
  StyledButton,
  StyledTextButton,
} from './interrupter-card.styled';

const getRandomInterrupter = (): InterrupterData => {
  const randomIndex = Math.floor(Math.random() * interrupterCards.length);
  return interrupterCards[randomIndex];
};

export const InterrupterCard: React.FC = () => {
  const [card] = useState(getRandomInterrupter);
  const intl = useIntl();
  const { config } = useSearchAndShuffleContext();

  return (
    <Container>
      <Title size="xxlarge">
        {intl.formatMessage({
          id: card.title,
        })}
      </Title>
      {card.description && (
        <Description>
          {intl.formatMessage({
            id: card.description,
          })}
        </Description>
      )}
      {card.tags && (
        <TagList>
          {card.tags.map((tag) => (
            <TagItem leadingIcon={IconTick} key={tag.id}>
              {intl.formatMessage({
                id: tag.label,
              })}
            </TagItem>
          ))}
          <DumbTile
            label={intl.formatMessage({
              id: 'DREAM_MACHINE_JOB_CARD_SKILLS_TILE_TITLE',
            })}
            title={`75/100`}
            progressBar={{
              progress: 75,
              showLabel: false,
              progressBarColor: xdlPaletteMint07,
            }}
            isBlurred={true}
          />
        </TagList>
      )}

      <ButtonContainer>
        <StyledButton
          to={config?.interrupterCards?.registrationUrl || ''}
          variant="secondary"
        >
          {intl.formatMessage({
            id: 'DREAM_MACHINE_INTERRUPTER_CARD_REGISTER_BUTTON',
          })}
        </StyledButton>
        <StyledTextButton to={config?.interrupterCards?.loginUrl || ''}>
          {intl.formatMessage({
            id: 'DREAM_MACHINE_INTERRUPTER_CARD_LOGIN_BUTTON',
          })}
        </StyledTextButton>
      </ButtonContainer>
    </Container>
  );
};
